import { UniverseImagePipe } from '@/domain/universes/pipes/universe-image.pipe';
import type { UniverseId } from '@/domain/universes/universe.interface';
import { SenAnalysisFeatureService } from '@/features/sen-analysis/sen-analysis-feature.service';
import { UiAvatarComponent } from '@/ui/avatar/ui-avatar';
import { PluralizePipe } from '@/utils/i18n/pluralize.pipe';
import { NgStyle } from '@angular/common';
import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { CoreSensor } from '../../../interfaces/Sensor.interface';
import { SensorsProvider } from '../../../providers/sensors/sensors.provider';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./sensor-info.scss'],
    selector: 'sensor-info',
    templateUrl: 'sensor-info.html',
    imports: [UiAvatarComponent, NgStyle, TranslatePipe, PluralizePipe, UniverseImagePipe]
})
export class SensorInfoComponent {
    private _sensorsProvider = inject(SensorsProvider);
    private _senAnalysisService = inject(SenAnalysisFeatureService);

    @Input() universeId!: UniverseId;
    @Input() sensors!: CoreSensor[];

    async goToSensorList() {
        if (!this.universeId) return;

        if (this.sensors.length > 1) {
            if (!(await this._senAnalysisService.hasFeatureAccess())) return;
            this._senAnalysisService.goToFeature([this.universeId]);
        } else {
            this._senAnalysisService.goToAnalysis(this.sensors[0].buildingId, [this.sensors[0].timeseriesId]);
        }
    }

    isSensorExtensive(): boolean | null {
        if (!Array.isArray(this.sensors) || this.sensors.length < 0) return null;
        return this._sensorsProvider.isSensorExtensive(this.sensors[0]);
    }
}
